
import React from "react";
import AppBar from "../../Components/header/index";
import AppProvider from "./../../Components/bootstrap"
import { MyProfile } from "./MyProfile"
import { useAuthenticated } from 'react-admin'

const SignUp = props => {
  useAuthenticated()
  return (
    <AppProvider>
      <AppBar />
      <MyProfile {...props}/>
    </AppProvider>
  );
};
export default SignUp;

